import { List } from 'immutable';

import { QUEUE_MESSAGE, POP_MESSAGE } from './actions';

export const MESSAGES_KEY = 'messages';

export const messagesReducer = (state = List(), action) => {
    switch (action.type) {
        case QUEUE_MESSAGE:
            const key = action.message.get('key');
            if (!key || !state.some(m => m.get('key') === key)) {
                return state.push(action.message);
            }
            break;
        case POP_MESSAGE:
            if (state.last()) {
                return state.pop();
            }
            break;
    }
    return state;
};
